export const baseImageRoute = "asset/guest";
